import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Observable } from 'rxjs';

@Injectable()
export class ErrorLanguageInterceptor implements HttpInterceptor {
  constructor(private translocoService: TranslocoService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const activeLang = this.translocoService.getActiveLang();
    const culture = toAspNetCulture(activeLang);

    // X-Language is what the API localizes by. `.AspNetCore.Culture` is only ever read as a cookie
    // (I18nService sets it), so sent as a header it was ignored and the browser's language won.
    const modifiedReq = req.clone({
      setHeaders: {
        'X-Language': culture,
      },
    });

    return next.handle(modifiedReq);
  }
}

function toAspNetCulture(translocoLang: string): string {
  const mappings: Record<string, string> = {
    en: 'en-US',
    pl: 'pl-PL',
    de: 'de-DE',
    fr: 'fr-FR',
    nl: 'nl-NL',
    es: 'es-ES',
    pt: 'pt-BR',
    ru: 'ru-RU',
    zh: 'zh-CN',
    ja: 'ja-JP',
  };

  return mappings[translocoLang] || 'en-US';
}
